module.exports = __webpack_public_path__ + "img/GiftCardList.434f9879.png";